// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","infiniteScrollWrapper":"infiniteScrollProductList_infiniteScrollWrapper__PpSv_","productCard":"infiniteScrollProductList_productCard__uKZ5x"};